import "./ListaNotas.css";

export default function ListaNotas({
  notas,
  moeda,
  formatarData,
  abrirItens,
}) {

  const notasFiltradas = notas.filter(
    (nota) =>
      Number(nota.codnatureza) === 5102 ||
      Number(nota.codnatureza) === 5910
  );

  if (notasFiltradas.length === 0) {
    return (
      <div className="listanotas-card">
        Nenhuma nota fiscal encontrada.
      </div>
    );
  }

  return (
    <div className="listanotas-card">

      <table className="listanotas-table">

        <thead>
          <tr>
            <th>Nota</th>
            <th>Data Saída</th>
            <th>Valor Total</th>
          </tr>
        </thead>

        <tbody>

          {notasFiltradas.map((nota) => (

            <tr
              key={nota.nronf}
              onClick={() =>
                abrirItens(
                  `Nota Fiscal ${nota.nronf}`,
                  nota.itens,
                  "nota"
                )
              }
            >
              <td>{nota.nronf}</td>

              <td>
                {formatarData(nota.datasaida)}
              </td>

              <td>
                {moeda(nota.valortotalnota)}
              </td>
            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
}